import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';
import { NotificationCard } from 'framework/ui/layout';
import { PoliciesDataType } from 'domain/shared/compliance';
import { useEmployeeUrl } from 'domain/shared/employee';
import { getComplianceDocumentNotificationContent } from './complianceDocumentNotificationHelper';

const EmployeeComplianceDocumentNotification = ({ response }: { response: PoliciesDataType[] }) => {
  const { getEmployeeDocumentSignUrl } = useEmployeeUrl();

  const onClick = (policyPath: string) => {
    const encodedPath = encodeURIComponent(policyPath);
    const url = getEmployeeDocumentSignUrl({ id: 'me', path: encodedPath });

    window.location.href = url;
  };

  return response.map(policy => {
    const content = getComplianceDocumentNotificationContent(policy);

    if (!content) return null;

    const { title, description, actionLabel } = content;

    return (
      <NotificationCard
        key={policy.policyPath}
        onClick={() => onClick(policy.policyPath)}
        title={title}
        description={description}
        actionLabel={actionLabel}
        accentColor="warning.main"
        accentSoftColor="background.warning"
        icon={<DescriptionOutlinedIcon sx={{ fontSize: 18 }} />}
      />
    );
  });
};

export default EmployeeComplianceDocumentNotification;
